import React, { useState, useEffect, useCallback } from 'react';
import { Select, notification } from 'antd';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { ORGANIZATIONS_LIST_REFRESH_EVENT } from '../../../config/appEvents';
import { DataService } from '../../../config/dataService/dataService';
import PermissionService from '../../../services/permissionService';

const OrganizationSelector = React.memo(() => {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(undefined);
  const [orgList, setOrgList] = useState([]);
  const user = JSON.parse(Cookies.get('user'));

  const handleSelectChange = async (value) => {
    setSelectedValue(value);

    try {
      const response = await DataService.put(`/v1/users/${user.id}`, { current_organization_id: value });
      if (response.data.success) {
        Cookies.set('currentOrganizationId', response.data.data.current_organization_id);

        // Load permissions for new organization
        try {
          // eslint-disable-next-line no-console
          await PermissionService.loadPermissionsForOrganization(value);
          // eslint-disable-next-line no-console

          // Reload page after permission update is complete
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } catch (permissionError) {
          // eslint-disable-next-line no-console
          console.warn('Failed to load permissions for new organization:', permissionError);
          notification.warning({
            message: 'Organization Changed',
            description: 'Organization changed but permissions could not be loaded.',
          });

          // Still reload even if permissions fail
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      } else {
        notification.error({
          message: 'Error',
          description: response.data.message,
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to change organization.',
      });
    }
  };

  const getOrgList = useCallback(async () => {
    const response = await DataService.get(`/v1/organizations?all=1`);
    if (response.data.success) {
      setOrgList(response.data.data);
      // Check if there's a currentOrganizationId in cookies and set it as selected value
      const currentOrgId = Cookies.get('currentOrganizationId');
      if (currentOrgId) {
        setSelectedValue(currentOrgId);
      }
    }
  }, []);

  useEffect(() => {
    getOrgList();
  }, [getOrgList]);

  useEffect(() => {
    const onOrganizationsRefresh = () => {
      getOrgList();
    };
    window.addEventListener(ORGANIZATIONS_LIST_REFRESH_EVENT, onOrganizationsRefresh);
    return () => window.removeEventListener(ORGANIZATIONS_LIST_REFRESH_EVENT, onOrganizationsRefresh);
  }, [getOrgList]);

  // Filter function to control which options are displayed when searching
  const filterOption = (input, option) =>
    String(option?.children ?? '')
      .toLowerCase()
      .includes(input.toLowerCase());

  return (
    <div className="ninjadash-nav-actions__item ninjadash-nav-actions__organization">
      <Select
        className="ninjadash-organization-select"
        placeholder={t('organization-select-placeholder', 'Organizasyon seçin')}
        value={selectedValue}
        onChange={handleSelectChange}
        showSearch
        filterOption={filterOption}
      >
        {orgList.map((org) => (
          <Select.Option key={org.id} value={org.id}>
            {org.name}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
});

export default OrganizationSelector;
